module.exports = __webpack_public_path__ + "img/borderless-plus-button.2d17132c.svg";